var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"toggle-button single"},[_c('v-btn',{class:_setup.dvalue?'selected':'unselected',attrs:{"block":"","disabled":_setup.compDisabled||_setup.compSkeleton,"outlined":"","color":_setup.dvalue?'primary':''},on:{"click":function($event){_setup.dvalue=!_setup.dvalue}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }